import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { DatePipe } from '@angular/common';
import * as moment from 'moment'; // add this 1 of 4
import { ParkingFeeService } from 'src/app/service/admin/parking-fee/parking-fee.service';
import { ParkingFee } from 'src/app/models/admin';

@Component({
  selector: 'app-shuttle-rate',
  templateUrl: './shuttle-rate.component.html',
  styleUrls: ['./shuttle-rate.component.css']
})
export class ShuttleRateComponent implements OnInit {
  me: any;
  rateForm: FormGroup;
  isValid: boolean;
  properties: any[];
  property_id: number;
  today_reservations_count: number;
  selectedDay: string;
  totalPersons: number[];

  constructor(private toastr: ToastrService,    public ref: ChangeDetectorRef,
    private formBuilder: FormBuilder, private service: ParkingFeeService) {
                this.isValid= false;
                this.properties = [];
                this.selectedDay = 'AC HOTELS BY MARRIOTT LOS ANGELES SOUTH BAY';
                this.totalPersons = [];
                for(let i=1; i<=12; i++) {
                  this.totalPersons.push(i);
                }
            }

  ngOnInit(): void {
    this.getUserProperties();
    this.initForm();
    this.getShuttle();
  }
  getUserProperties() {
    this.service.getUserProperties().subscribe((res: any) => {
      let first = _.first(res.property);
      this.property_id = first.id;
      this.properties = res.property;
    });
    this.getMe();
  }

  selectChangeHandler(event: any) {
    if (event.target.value) {
      this.selectedDay = event.target.options[event.target.options.selectedIndex].text;
      this.property_id = event.target.value;
      this.ngOnInit();
    }

  }
  resetTags() {
    const arr = this.rateForm.controls.rate as FormArray;
    while (0 !== arr.length) {
      arr.removeAt(0);
    }
  }
  bindData(data:any){

    this.rateForm.get('defaultRate').setValue(data?.defaultRate);
    this.resetTags();
    for (let row of data?.rate) {

      this.add();


    }
    this.rateForm.get('rate').setValue(data?.rate);
    this.ref.detectChanges();
      

  }
  getMe() {
    this.service.getMe().subscribe((res: any) => {
      this.me = res;
    });
  }

  initForm() {
    this.rateForm = this.formBuilder.group({
      defaultRate: ['0'],
      rate: this.formBuilder.array([this.newRate()]),
    });
  }

  get rate(): FormArray {
    return this.rateForm.get('rate') as FormArray;
  }

  newRate(): FormGroup {
    return this.formBuilder.group({
      id: [''],
      no_of_person: ['',[Validators.required]],
      rate: ['',[Validators.required, Validators.pattern(/^\s*-?[0-9]\d*(\.\d{1,2})?\s*$/)]],
      tax: ['0',[Validators.required, Validators.pattern(/^\s*-?[0-9]\d*(\.\d{1,2})?\s*$/)]]
    });
  }

  totalRate(): void {
    this.rate.push(this.newRate());
  }

  remove(index:number) {
    this.rate.removeAt(index);
  }

  add() {
    let formArray = this.rateForm.get('rate') as FormArray;
    return formArray.push(this.newRate());
  }

  submitRate() {
    this.isValid = true;
    if (this.rateForm.valid) {
      this.addRateForm(this.rateForm.value);
    } 
  }
  getShuttle(){
    this.service.getShuttle().subscribe((res:any)=>{
      if(res?.status==true){
        this.bindData(res?.data);
      }
      
    });
  }

  addRateForm(data: any) {
   this.service.addShuttle(data).subscribe((res:any)=>{
    if (res.status == true) {
      this.toastr.success(res.message);
      this.getShuttle();
    } else {
      this.toastr.success(res.message);
    }


   });
  }

  changeDefaultRate() {
    
  }
  
  personsChange(event: any) {
    
  }

}
